angular.module('app.filters')
.filter('transcoderProfile', () =>
    function(input) {
        let profile = input;

        let lowCost = false;
        if (profile.includes('plc')) {
            lowCost = true;
            profile = profile.replace('plc', 'p');
        }

        let hevc = false;
        if (profile.includes(':hevc')) {
            hevc = true;
            profile = profile.replace(':hevc', '');
        }

        let rtmp = false;
        if (profile.includes(':rtmp')) {
            rtmp = true;
            profile = profile.replace(':rtmp', '');
        }

        let upscaled = false;
        if (profile.includes(':us')) {
            upscaled = true;
            profile = profile.replace(':us', '');
        }

        let passThrough = false;
        if (profile.endsWith("Pass")) {
            passThrough = true;
            profile = profile.replace(/Pass$/, '');
        }

        let only = false;
        if (profile.endsWith("Only")) {
            only = true;
            profile = profile.replace(/Only$/, '');
        }

        let extraStr = '';
        if (lowCost) {
            extraStr = ' (low-cost)';
        } else if (hevc) {
            extraStr = ' (HEVC)';
        } else if (rtmp) {
            extraStr = ' (RTMP)';
        } else if (upscaled) {
            extraStr = ' (HDSD2)';
        } else if (passThrough) {
            extraStr = ' (pass-through)';
        } else if (only) {
            extraStr = ' only';
        }

        return `${profile}${extraStr}`;
    }
);


// WEBPACK FOOTER //
// ./filters/transcoder_profile.js